import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Button from '@atlaskit/button/custom-theme-button';
export default /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var truncationWidth = _ref.truncationWidth,
      _ref$hasOverflow = _ref.hasOverflow,
      hasOverflow = _ref$hasOverflow === void 0 ? true : _ref$hasOverflow,
      iconBefore = _ref.iconBefore,
      iconAfter = _ref.iconAfter,
      props = _objectWithoutProperties(_ref, ["truncationWidth", "hasOverflow", "iconBefore", "iconAfter"]);

  return /*#__PURE__*/React.createElement(Button, _extends({
    appearance: "subtle-link",
    spacing: "none",
    iconAfter: hasOverflow ? undefined : iconAfter,
    iconBefore: hasOverflow ? undefined : iconBefore,
    ref: ref
  }, props, {
    theme: function theme(currentTheme, themeProps) {
      var _currentTheme = currentTheme(themeProps),
          buttonStyles = _currentTheme.buttonStyles,
          rest = _objectWithoutProperties(_currentTheme, ["buttonStyles"]);

      return _objectSpread({
        buttonStyles: _objectSpread(_objectSpread({}, buttonStyles), {}, {
          fontWeight: 400
        }, truncationWidth ? {
          maxWidth: "".concat(truncationWidth, "px !important")
        } : {
          flexShrink: 1,
          minWidth: 0
        })
      }, rest);
    }
  }));
});